























import Vue from 'vue';
import { Component, Prop, Watch } from 'vue-property-decorator';
import { getLeadsRemark, addLeadsRemark } from '@/api/school';
import { TAddLeadsRemark } from '@/types/views/school';
@Component({})
export default class Remark extends Vue {
  @Prop({
    type: Function,
    default() {
      return function() {};
    }
  })
  getData!: Function;
  @Prop({
    type: Number,
    default() {
      return 0;
    }
  })
  id!: number;
  @Watch('id')
  watchId(val: number) {
    this.getRemarkById();
  }
  private dialogVisible = false;
  private comment = '';
  private remarks = [];

  private async getRemarkById() {
    try {
      let res: any = await getLeadsRemark({ id: this.id });
      this.remarks = res;
    } catch (e) {
      this.$message.error(e.message);
    }
  }
  private handleClose() {
    this.comment = '';
    this.dialogVisible = false;
  }
  private async handlePost() {
    if (!this.comment) {
      this.$message.error('内容不能为空');
      return;
    }
    let opts: TAddLeadsRemark = {
      orguserid: this.id,
      content: this.comment
    };
    try {
      await addLeadsRemark(opts);
    } catch (e) {
      this.$message.error(e.message);
    }
    this.getData();

    this.handleClose();
  }
}
